<script>
  export default {
    props: ['data'],
  }
</script>

<template>
  <div>
    <table class="table table-striped table-bordered f12">
      <thead>
        <tr class="bg-head1">
          <th style="width: 50px"><b>STT</b></th>
          <th><b>Loại thẻ/Phương thức thanh toán</b></th>
          <th class="txt-center"><b>Mức phí</b></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td class="txt-center">{{ index + 1 }}</td>
          <td>{{ item.issuerName }}/{{ item.paymentMethod }}</td>
          <td class="txt-center">
            <span :class="item.isDefaultFee === false && 'bg-yellow'">
              <b>{{ item.feePerTransaction }} %</b>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="f14"><b>Lưu ý: </b></p>
    <ol class="text-left form-style2 f12">
      <li><i>Đơn vị tính là VNĐ và đã bao gồm VAT.</i></li>
      <li>
        <i>Biểu phí này căn cứ theo chính sách của Bên A được ban hành tại từng thời điểm.</i>
      </li>
    </ol>
  </div>
</template>
